var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9023 8.60938H5.09766C2.29259 8.60938 0 10.8919 0 13.707V44.293C0 47.1091 2.29406 49.3906 5.09766 49.3906H52.9023C55.7074 49.3906 58 47.1081 58 44.293V13.707C58 10.8912 55.7063 8.60938 52.9023 8.60938ZM52.1196 12.0078C50.4714 13.6614 31.1121 33.0838 30.3168 33.8817C29.6525 34.5481 28.3478 34.5485 27.6832 33.8817L5.88043 12.0078H52.1196ZM3.39844 43.6682V14.3318L18.0191 29L3.39844 43.6682ZM5.88043 45.9922L20.4183 31.407L25.2763 36.2809C27.2671 38.2782 30.7337 38.2774 32.7238 36.2809L37.5818 31.4071L52.1196 45.9922H5.88043ZM54.6016 43.6682L39.9809 29L54.6016 14.3318V43.6682Z",
    fill: "#006FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b0be76a3ca62d018f3266d51c30b8dca.svg";
export { ForwardRef as ReactComponent };